import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.array.push.js";
import * as creditService from '@/services/credit';
import { Toast } from 'vant';
export var useCreditStore = defineStore('credit', {
    state: function() {
        return {
            dictionary: null,
            provinceDictionary: null,
            bankTypeList: null
        };
    },
    getters: {},
    actions: {
        update: function(payload) {
            this.$patch(payload);
            if (payload.dictionary) {
                this.$patch({
                    dictionary: payload.dictionary
                });
            }
            if (payload.provinceDictionary) {
                this.$patch({
                    provinceDictionary: payload.provinceDictionary
                });
            }
            if (payload.bankTypeList) {
                this.$patch({
                    bankTypeList: payload.bankTypeList
                });
            }
        },
        logout: function() {
            return _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    this.$reset();
                    return [
                        2
                    ];
                });
            }).apply(this);
        },
        reqDictionary: // 字典
        function() {
            return _async_to_generator(function() {
                var result, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                creditService.queryDictionary({})
                            ];
                        case 1:
                            result = _state.sent();
                            this.update({
                                dictionary: result
                            });
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            Toast(error.message);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        reqProviceDictionary: // 省市字典
        function() {
            return _async_to_generator(function() {
                var result, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                creditService.queryProviceDictionary({})
                            ];
                        case 1:
                            result = _state.sent();
                            this.update({
                                provinceDictionary: result
                            });
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            Toast(error.message);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        reqBankTypeList: // 放款方式列表
        function() {
            return _async_to_generator(function() {
                var result, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                creditService.queryBankTypeList({})
                            ];
                        case 1:
                            result = _state.sent();
                            this.update({
                                bankTypeList: result
                            });
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            Toast(error.message);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        reqCreditSubmit: // 授信提交
        function(params) {
            return _async_to_generator(function() {
                var routeObj, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                creditService.queryCreditSubmit(params)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this.reqCreditStep()
                            ];
                        case 2:
                            routeObj = _state.sent();
                            return [
                                2,
                                routeObj
                            ];
                        case 3:
                            error = _state.sent();
                            Toast(error.message);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        reqOcrResult: // ocr识别
        function(params) {
            return _async_to_generator(function() {
                var result, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                creditService.queryOcrResult(params)
                            ];
                        case 1:
                            result = _state.sent();
                            console.log(result, 'ocr result');
                            return [
                                2,
                                result
                            ];
                        case 2:
                            error = _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        reqOcrSubmit: // ocr提交
        function(params) {
            return _async_to_generator(function() {
                var routeObj, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                creditService.queryOcrSubmit(params)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this.reqCreditStep()
                            ];
                        case 2:
                            routeObj = _state.sent();
                            return [
                                2,
                                routeObj
                            ];
                        case 3:
                            error = _state.sent();
                            Toast(error.message);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        reqCreditStep: // 查询授信step
        function() {
            return _async_to_generator(function() {
                var result, routeObj, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                creditService.queryCreditStep({})
                            ];
                        case 1:
                            result = _state.sent();
                            console.log(result, 'queryqueryCreditStepstep');
                            return [
                                4,
                                this.toNextPage(result)
                            ];
                        case 2:
                            routeObj = _state.sent();
                            return [
                                2,
                                routeObj
                            ];
                        case 3:
                            error = _state.sent();
                            Toast(error.message);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        toNextPage: /**
    0-already summit credit -> examine page
    1-personData —> information
    2-jobInfo ->  information
    3-contactInfo -> contact
    4-ocr -> idMessage
    5-face recognition -> face
    // 6-retry credit ->  examine page
    7-contactInfo -> contact
    8-final review already submit ->  examine page
    9-postposition face recognition -> face
    12-jobInfo -> information
    13-bankInfo -> information
    // 14-creditLimitPopup ->  examine page
     */ function(result) {
            return _async_to_generator(function() {
                var path, query, resultStatus, livenessWay, routeObj;
                return _ts_generator(this, function(_state) {
                    path = '';
                    query = {};
                    resultStatus = result.resultStatus, livenessWay = result.livenessWay;
                    switch(resultStatus){
                        case 0:
                        case 8:
                            path = '/result';
                            break;
                        case 1:
                            path = '/information';
                            break;
                        case 2:
                            path = '/information';
                            break;
                        case 3:
                            path = '/contacts';
                            break;
                        case 4:
                            path = '/idMessage';
                            break;
                        case 5:
                            path = '/face';
                            query.isCredit = 0;
                            query.isAdvance = livenessWay;
                            break;
                        case 7:
                            path = '/contacts';
                            break;
                        case 9:
                            path = '/face';
                            query.isCredit = 1;
                            query.isAdvance = livenessWay;
                            break;
                        case 12:
                            path = '/information';
                            break;
                        case 13:
                            path = '/information';
                            break;
                        case 14:
                            path = '/collect-sms';
                            break;
                        default:
                            break;
                    }
                    routeObj = {
                        path: path,
                        query: query
                    };
                    return [
                        2,
                        routeObj
                    ];
                });
            })();
        },
        reqCreditStatus: // 查询通用状态
        function() {
            return _async_to_generator(function() {
                var clientState, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                creditService.queryCreditStatus({})
                            ];
                        case 1:
                            clientState = _state.sent().clientState;
                            console.log(clientState, 'credit status code');
                            return [
                                2,
                                clientState
                            ];
                        case 2:
                            error = _state.sent();
                            Toast(error.message);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        reqLoanStatus: // 查询提现状态
        function() {
            return _async_to_generator(function() {
                var clientState, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                creditService.queryLoanStatus({})
                            ];
                        case 1:
                            clientState = _state.sent().clientState;
                            console.log(clientState, 'loan status code');
                            return [
                                2,
                                clientState
                            ];
                        case 2:
                            error = _state.sent();
                            Toast(error.message);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        reqSubmitCredit: // 发起授信
        function(params) {
            return _async_to_generator(function() {
                var routeObj, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                creditService.submitCredit(params)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this.reqCreditStep()
                            ];
                        case 2:
                            routeObj = _state.sent();
                            return [
                                2,
                                routeObj
                            ];
                        case 3:
                            error = _state.sent();
                            Toast(error.message);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        }
    },
    persist: {
        paths: [
            'dictionary',
            'provinceDictionary'
        ]
    }
});
